module.exports = {"en":{"title":"You may be interested in","empty":"No recommendation","loading":"Loading...","add":"Add to cart","remove":"Remove","year":"Year"},"zh":{"title":"您可能感兴趣的域名","empty":"没有推荐的域名","loading":"正在载入...","add":"加入清单","remove":"移出清单","year":"年"}}


//////////////////
// WEBPACK FOOTER
// ./src/recommend/i18n.json
// module id = 145
// module chunks = 0